import { map as rxjsmap } from 'rxjs';

import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ContactEdit } from './../models/contactEdit';
import { ContactFunctionalArea } from './../models/contactFunctionalArea';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ContactServices {
  item: Object;
  constructor(private http: HttpClient) {}

  getContactById(id: number) {
    return this.http
      .get(environment.BASE_URL + '/contact/' + id).pipe(rxjsmap((result: any) => result));
  }

  add(data: any) {
    let body = JSON.stringify(data);
    return this.http
      .post(environment.BASE_URL + '/contact', body).pipe(rxjsmap(result => result));
  }

  update(ExistingEmployee: ContactEdit) {
    return this.http
      .put(environment.BASE_URL + '/contactUpdate', ExistingEmployee).pipe(rxjsmap(result => result));
  }

  // delete selected contacts
  deleteAll(Ids: any) {
    return this.http
      .put(environment.BASE_URL + '/contacts', Ids).pipe(rxjsmap(result => result));
  }

  // // get all contact type
  getAllContactType() {
    return this.http
      .get<any>(environment.BASE_URL + '/contacttypes/contactTypes').pipe(rxjsmap(result => result));
  }

  // bind contact function
  getAllByFunction() {
    return this.http
      .get<any>(environment.BASE_URL + '/contactfunctions/contactFunctions').pipe(rxjsmap(result => result));
  }

  // update contact function
  updateFunction(existingCategory: ContactFunctionalArea) {
    return this.http
      .put(
        environment.BASE_URL +
          '/contactfunctions/contactfunction/' +
          existingCategory.Id,
        existingCategory
      ).pipe(rxjsmap(result => result));
  }

  // adding contact function
  createFunction(newCategory: ContactFunctionalArea) {
    return this.http
      .post(
        environment.BASE_URL + '/contactfunctions/contacFunction',
        newCategory
      ).pipe(rxjsmap(result => result));
  }

  // delete popup values
  deleteType(Id: number) {
    return this.http
      .delete(environment.BASE_URL + '/contactfunctions/contactfunctions/' + Id).pipe(rxjsmap(result => result));
  }

  getAllCustContacts() {
    return this.http
      .get<any>(environment.BASE_URL + '/cutomerContacts').pipe(rxjsmap(result => result));
  }
  getAllCustContactsWithLogin() {
    return this.http
      .get<any>(environment.BASE_URL + '/cutomerContactsLogin').pipe(rxjsmap(result => result));
  }
  deleteCustConatcts(ids: any) {
    return this.http
      .put(environment.BASE_URL + '/cutomerContacts', ids).pipe(rxjsmap(result => result));
  }
  checkExistingFunction(functionId: any) {
    return this.http
      .get(
        environment.BASE_URL + '/contactfunctions/checkfunction/' + functionId
      ).pipe(rxjsmap(result => result));
  }
}
